export enum OutcomeType {
  TranResult = 'TRAN_RESULT',
  AcquirerResult = 'ACQ_RESULT',
  IssuerInstalmentResult = 'ISSUER_INSTALMENT_RESULT',
}
